import TimelineItem from 'components/TimelineItem';
import ActivityTimeText from 'components/text/ActivityTimeText';
import BodyText from 'components/text/BodyText';
import TableHeaderText from 'components/text/TableHeaderText';

import useTranslation from './hooks/useTranslation';

import { META_SEPARATOR, TEST_ID, TITLE_SEPARATOR } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceLogEntry: FunctionComponent<Props> = ({
    className = '',
    eventType,
    modelNumber,
    notes,
    partLabel,
    performedAt,
    performedBy,
    testId = TEST_ID
}) => {
    const eventLabels = useTranslation();

    const modelSuffix = modelNumber ? ` (${modelNumber})` : '';
    const eventLabel = `${eventLabels[eventType]}${modelSuffix}`;

    const title = partLabel ? `${partLabel}${TITLE_SEPARATOR}${eventLabel}` : eventLabel;
    const metaText = performedBy ? `${performedAt}${META_SEPARATOR}${performedBy}` : performedAt;
    const notesText = notes ? <BodyText className={styles.notes} text={notes} /> : null;

    return (
        <TimelineItem className={`${className} ${styles.serviceLogEntry}`} testId={testId}>
            <TableHeaderText text={title} />

            <ActivityTimeText text={metaText} />

            {notesText}
        </TimelineItem>
    );
};

export default ServiceLogEntry;
